// src/components/Loader/Loader.js
import React from "react";
import styles from "./Loader.module.scss";

const Loader = () => {
  return (
    <div className={styles.loader_overlay}>
      <div className={styles.spinner}></div>
    </div>
  );
};

export default Loader;
